// Third-party
import { useTranslation } from 'react-i18next';

// Components
import { BaseDialog, TDialogAction } from '@mgm/common/components/base';

// Hooks
import { useDeleteShiftAPI } from '../../../../../hooks/api/useSheets';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/useAppStore';

// Redux-toolkit
import { getIsOpenDeleteShiftDialog } from '../../../../../store/sheets/selectors';
import { sheetsActions } from '../../../../../store/sheets/slice';

const DeleteShiftDialog = () => {
  const { t } = useTranslation(['common', 'timesheets']);
  const { mutateAsync: deleteMutate, isLoading } = useDeleteShiftAPI();
  const isOpenDialog = useAppSelector(getIsOpenDeleteShiftDialog);
  const dispatch = useAppDispatch();

  const handleCloseDialog = () => {
    dispatch(sheetsActions.setToggleDeleteShift(false));
  };

  const deleteShift = async () => {
    await deleteMutate();
  };

  const dialogActions: Array<TDialogAction> = [
    {
      label: t('cancel'),
      variant: 'outlined',
      color: 'primary',
      isDisabled: isLoading,
      onClick: () => handleCloseDialog(),
    },
    {
      label: t('delete'),
      color: 'primary',
      isLoading,
      onClick: () => deleteShift(),
    },
  ];

  return (
    <BaseDialog
      dialogContent={t('deleteShiftSubtitle', { ns: 'timesheets' })}
      isOpenDialog={isOpenDialog}
      dialogTitle={t('deleteShift', { ns: 'timesheets' })}
      handleClose={handleCloseDialog}
      dialogActions={dialogActions}
    />
  );
};

export {
  DeleteShiftDialog,
};
